import { Trans } from 'react-i18next';

const DRAFT = 'draft';
const ACTIVE = 'active';
const DEACTIVATED = 'deactivated';
const READY_TO_ACTIVATE = 'readyToActivate';

const BIRTHDAY_i18Key = 'birthday';
const WORK_ANNIVERSARY_i18Key = 'workAnniversary';

const AUTOMATION_CREATION_STEPS = {
  newAutomationGifts: 'NEW_AUTOMATION_GIFTS',
  newAutomationRules: 'NEW_AUTOMATION_RULES',
  newAutomationExperience: 'NEW_AUTOMATION_EXPERIENCE',
  newAutomationRecipients: 'NEW_AUTOMATION_RECIPIENTS',
  newAutomationReviewActive: 'NEW_AUTOMATION_REVIEW_PAY'
};

const ACTIVE_AUTOMATION_FILTERS_BY_STATUS = {
  [READY_TO_ACTIVATE]: [AUTOMATION_CREATION_STEPS.newAutomationReviewActive],
  [DRAFT]: [
    AUTOMATION_CREATION_STEPS.newAutomationGifts,
    AUTOMATION_CREATION_STEPS.newAutomationRules,
    AUTOMATION_CREATION_STEPS.newAutomationExperience,
    AUTOMATION_CREATION_STEPS.newAutomationRecipients
  ]
};

const AUTOMATION_LIST_TABLE_LIMIT = 10;

const AUTOMATION_STATUSES = {
  [DRAFT]: DRAFT,
  [ACTIVE]: ACTIVE,
  [DEACTIVATED]: DEACTIVATED,
  [READY_TO_ACTIVATE]: READY_TO_ACTIVATE
};

const AUTOMATION_FILTER_STATUSES = {
  [DRAFT]: DRAFT,
  [ACTIVE]: ACTIVE,
  [DEACTIVATED]: DEACTIVATED,
  [READY_TO_ACTIVATE]: DRAFT
};

const OCCASION = {
  workAnniversary: 'work-anniversary',
  birthday: 'birthday'
};

const AVAILABLE_OCCASION_NAMES = {
  [OCCASION.workAnniversary]: WORK_ANNIVERSARY_i18Key,
  [OCCASION.birthday]: BIRTHDAY_i18Key
};

const OCCASION_TYPES = {
  [OCCASION.workAnniversary]: 'Work Anniversary',
  [OCCASION.birthday]: 'birthday'
};

const NON_EDITABLE_AUTOMATION_STATUS = [];

const expirationDuration = [
  { label: <Trans i18nKey="oneWeek" />, value: 7 * 24 },
  { label: <Trans i18nKey="amountWeek" values={{ amount: 2 }} />, value: 14 * 24 },
  { label: <Trans i18nKey="amountWeek" values={{ amount: 3 }} />, value: 21 * 24 }
];

const scheduleDuration = [
  { label: <Trans i18nKey="sameDay" />, value: 0 },
  { label: <Trans i18nKey="amountDaysBefore" values={{ amount: 3 }} />, value: 3 },
  { label: <Trans i18nKey="amountDaysBefore" values={{ amount: 5 }} />, value: 5 },
  { label: <Trans i18nKey="oneWeekBefore" />, value: 7 }
];

export {
  ACTIVE_AUTOMATION_FILTERS_BY_STATUS,
  AUTOMATION_CREATION_STEPS,
  AUTOMATION_FILTER_STATUSES,
  AUTOMATION_LIST_TABLE_LIMIT,
  AUTOMATION_STATUSES,
  AVAILABLE_OCCASION_NAMES,
  NON_EDITABLE_AUTOMATION_STATUS,
  OCCASION,
  OCCASION_TYPES,
  expirationDuration,
  scheduleDuration
};
